<template style="z-index: 100;">
  <v-layout column>
    <v-flex>
      <app-google-translator/>
    </v-flex>
    <v-flex>
      <div class="appConfirmationTitle">
        Unfortunately, it looks like your link has expired.
        If you have any questions, please contact our customer support at
        <a :href="emailLink">{{ email }}</a>.
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import AppGoogleTranslator from 'components/AppGoogleTranslator.vue';
import urlUtils from 'utils/url';

export default {
  components: {
    AppGoogleTranslator,
  },
  computed: {
    email() {
      const productFromUrl = urlUtils.getProductFromDomain();

      return productFromUrl !== 'enhancedrefundprogram' ? 'help@protecht.com' : 'help@fanshield.com';
    },
    emailLink() {
      return `mailto:${this.email}`;
    },
  },
};
</script>

<style scoped>
.appConfirmationTitle {
  font-family: Gotham;
  font-size: 26px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
